<div [ngClass]="{ load: !fileContent }">
  <h2 mat-dialog-title class="mat-title">
    Third party notices
    <div (click)="onCancelClick()">
    <span class="close-dialog">&#10006;</span>
    </div>
  </h2>

  <mat-dialog-content *ngIf="fileContent">
    <p [innerText]="fileContent"></p>
  </mat-dialog-content>
</div>
